import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './en.json';
import es from './es.json';

function international(lng) {
  i18n.use(initReactI18next).init(
    {
      interpolation: {
        escapeValue: false,
        prefix: '{',
        suffix: '}',
      },
      lng, // 'en' | 'es'
      resources: {
        en: {
          translation: en,
        },
        es: {
          translation: es,
        },
      },
    },
    (err) => {
      if (err) {
        throw new Error(err);
      }
    }
  );

  return i18n;
}

export default international;
